import { render, staticRenderFns } from "./NoRequestsCard.vue?vue&type=template&id=47fe1d28&lang=pug"
import script from "./NoRequestsCard.vue?vue&type=script&lang=js"
export * from "./NoRequestsCard.vue?vue&type=script&lang=js"
import style0 from "./NoRequestsCard.vue?vue&type=style&index=0&id=47fe1d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports